import { useState } from 'react'

/** Boolean state toggle utility with the ability to pass an overriding boolean state */
export function useToggleState(initialState: boolean | (() => boolean)): [boolean, (overrideValue?: boolean) => void] {
  const [state, setState] = useState(initialState)

  return [state, (overrideValue) => setState((prev) => overrideValue ?? !prev)]
}
